import AuthenticationProcessesNewStepModalView from "./AuthenticationProcessesNewStepModal.html";

angular.module('authentication_processes')

    .controller("authenticationProcessesEditCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state', '$stateParams', 'logService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state, $stateParams, logService) {

            $rootScope.title = $filter('translate')('authentication_processes.title');

            $scope.allowWrite = true;

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('authentication_processes.title'), url: "authentication_processes.list" },
                    { title: $filter('translate')('general.add') },
                ];
            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('authentication_processes.title'), url: "authentication_processes.list" },
                    { title: $filter('translate')('general.edit') },
                ];
            }

            Restangular.one('AuthenticationProcesses', $stateParams.id).get().then(function (result) {
                $scope.authentication_process = result.id ? result : { Steps: [] };
                $scope.configureSteps();
            });

            $scope.saveAuthenticationProcess = function () {
                if (angular.isDefined($scope.authentication_process.id)) {
                    $scope.authentication_process.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('authentication_processes.save_success'));
                            $state.go("authentication_processes.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('AuthenticationProcesses').post($scope.authentication_process).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('authentication_processes.save_success'));
                            $state.go("authentication_processes.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            }

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('general.button_delete'),
                    message: $filter('translate')('authentication_processes.delete_message'),
                    onAccept: function () {
                        $scope.authentication_process.remove().then(function () {
                            toastr.success($filter('translate')('authentication_processes.deleted_success'));
                            $state.go("authentication_processes.list");
                        });
                    }
                });
            };

            $scope.configureSteps = function () {
                let i = 0;
                $scope.authentication_process.Steps.forEach(function (f) {
                    f.inGrid = true;
                })
                $scope.gridOptionsSteps.data = $scope.authentication_process.Steps;
            }

                // $scope.allowWrite = LoginService.permissionExist("AUTHENTICATION_SERVICES_WRITE");
                $scope.gridOptionsSteps = {
                    pdfTitle: "Steps",
                    exporterMenuCsv: true,
                    enableGridMenu: true,
                    gridMenuShowHideColumns: false,
                    enableSorting: true,
                    paginationPageSizes: [20, 40, 60],
                    paginationPageSize: 20,
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    },
                    columnDefs: [
                        { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                        { name: 'Order', displayName: $filter('translate')('passbooks.field_order'), enableFiltering: true, enableHiding: false },
                        { name: 'UserPassword', displayName: $filter('translate')('authentication_processes_steps.user_password'), enableFiltering: true, enableHiding: false, cellTemplate: '<div style="margin-left: 10px"><span ng-if="row.entity.UserPassword"><i class="fas fa-check"></i></span></div>' },
                        { name: 'OAuth', enableFiltering: true, enableHiding: false, cellTemplate: '<div style="margin-left: 10px"><span ng-if="row.entity.OAuth"><i class="fas fa-check"></i></span></div>' },
                        { name: 'Authenticator', enableFiltering: true, enableHiding: false, cellTemplate: '<div style="margin-left: 10px"><span ng-if="row.entity.Authenticator"><i class="fas fa-check"></i></span></div>' },
                        { name: 'YubicoOTP', enableFiltering: true, enableHiding: false, cellTemplate: '<div style="margin-left: 10px"><span ng-if="row.entity.YubicoOTP"><i class="fas fa-check"></i></span></div>' },
                        { name: 'WebAuthn', enableFiltering: true, enableHiding: false, cellTemplate: '<div style="margin-left: 10px"><span ng-if="row.entity.WebAuthn"><i class="fas fa-check"></i></span></div>'},
                        {
                            name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                                { title: $filter('translate')('general.button_edit'), action: 'ng-click="grid.appScope.addStep(row.entity)"; ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                                { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.removeStep(row.entity)"; ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                            ], { cssClass: "pull-right" })
                        },
                    ],
            };

            $scope.addStep = function (step) {
                step ? $scope.step = step : $scope.step = {};
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AuthenticationProcessesNewStepModalView,
                    controller: "AuthenticationProcessesNewStepModalCtrl",
                    resolve: {},
                    scope: $scope,
                    size: 'lg'
                });
            };

            $scope.removeStep = function (step) {
                modalService.confirm({
                    title: $filter('translate')('events_types.button_delete'),
                    message: $filter('translate')('authentication_processes.step_delete_message'),
                    onAccept: function () {
                        let index = $scope.authentication_process.Steps.indexOf(step)
                        $scope.authentication_process.Steps(index, 1);
                        }
                    });
            };

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('events_types.button_delete'),
                    message: $filter('translate')('authentication_processes.delete_message'),
                    onAccept: function () {
                        Restangular.one('AuthenticationProcesses', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('authentication_processes.deleted_success'));
                            $scope.gridOptionsSteps.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });
            }
        }])
    .controller("AuthenticationProcessesNewStepModalCtrl", ['$scope', '$uibModalInstance', 'modalService', '$filter', 'logService',
        function ($scope, $uibModalInstance, modalService, $filter, logService) {

        $scope.newStepTitle = $scope.step.id ? ($filter('translate')('authentication_processes.step_edit')) : ($filter('translate')('authentication_processes.step_add'));
        let defaultPosition;
        // Sugerimos una posición por defecto
        let orderList = $scope.authentication_process.Steps.map(f => f.Order);

        if (orderList.length > 0) {
            defaultPosition = Math.max(...orderList) + 1;
        }
        if (!defaultPosition) {
            defaultPosition = 1;
        };

        $scope.step.Order = $scope.step.Order ? $scope.step.Order : defaultPosition;

        $scope.onCancel = function () {
            $scope.newField = {};
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onAccept = function () {
            if (!$scope.step.inGrid) {
                $scope.authentication_process.Steps.push($scope.step);
            };
            $scope.configureSteps();
            $scope.step = {};
            $uibModalInstance.close();
        };

    }]);